import React, { useRef,useContext  } from 'react';
import { useLocation,useNavigate } from "react-router-dom"

import Context from '../context/context';
import PasswordReset from '../passwordReset/passwordReset';
import Adult from '../offers/adult1.js';
import Mainstream from '../offers/ms1.js';
import Autologin from '../autologin/switcher.js';
import ConfirmEmail from '../autologin/doiConfirm';
import AutologinTelegram from '../autologin/autologin_da_telegram.js';
import NavbarDesktop from '../navbar_desktop';
import NavbarMobileNew from '../menu/menu_mobile_top.js';
import Homepage from '../homepage/homepage';
import Signup from '../homepage/signup';
import Login from '../homepage/login';
import ForgotPassword from '../homepage/forgot.js';
import Legal from '../legal/legal';
import ContactUs from '../contactUs/contactUs.js';
import Spinner from '../spinner/spinner';
import PaymentPage from '../payment/paymentPage';
import Cookie from '../cookie/cookie';



const config = require("../_helpers/configServizi");


export default function CatchAll(props) {

    const domain = window.location.hostname;
    const  context = useContext(Context)
    
    const firstUpdate = useRef(true);
    const location = useLocation();

    const navigate = useNavigate();

    console.log(location.pathname)



    function Not_found(){
        const protocollo = window.location.protocol
        const dominio = window.location.host
        window.location.replace(protocollo+"//"+dominio)
    }


    if (firstUpdate.current) {
        firstUpdate.current = false;
        return (<Spinner/>);
    }

    

    if(location.pathname == "/login"){
        props.onHide();
        return (
           <Login/>
        )
    }





    if(location.pathname == "/find" || location.pathname == "/asignup" || location.pathname == "/loginWithGoogle"){
        context.setStatoSignupForm(true)

        return (
            <React.Fragment>
                <NavbarDesktop/>
                <NavbarMobileNew crediti={0}/>
                {!config.servizi[domain].mainstream ? ( <Adult/>) : (<Mainstream/>)}
               
            </React.Fragment>
        )
    }


    if(location.pathname == "/ms"){
        context.setStatoSignupForm(true)
        return (
            <React.Fragment>
                <NavbarDesktop/>
                <NavbarMobileNew crediti={0}/>
                <Mainstream/>
            </React.Fragment>
        )
    }
    
    
    if(location.pathname == "/autologin"){
      
        props.onHide();
        return (
            <React.Fragment>
                <Autologin reload={firstUpdate}/>
            </React.Fragment>
        )
    }


    if(location.pathname == "/confirmEmail"){
      
        props.onHide();
        return (
            <React.Fragment>
                <ConfirmEmail reload={firstUpdate}/>
            </React.Fragment>
        )
    }


    if(location.pathname == "/autologin_telegram"){
      
        props.onHide();
        return (
            <React.Fragment>
                <AutologinTelegram reload={firstUpdate}/>
            </React.Fragment>
        )
    }



    if(location.pathname == "/contactUs"){
        props.onHide();
        return (
           <ContactUs/>
        )
    }

    if(location.pathname == "/signup"){
        props.onHide();
        return (
           <Signup/>
        )
    }


    


    if(location.pathname == "/paymentPage"){
        props.onHide();
        return (
           <PaymentPage/>
        )
    }

    


    if(location.pathname != "/"){

        
        let params = location.pathname.split("/")
        
        if(params[1] == "legal"){
            props.onHide()
            if( params[2] == "faq" || params[2] == "cookie" || params[2] == "privacy" || params[2] == "terms" || params[2] == "features"){
                return (<Legal  pagina={params[2]}/>)
            }else{
                return  (<React.Fragment>
                        <Homepage />
                        {context.cookiePolicy != "true" && <Cookie/>}
                    </React.Fragment>
                )
            }
        }
       
    }

    if(location.pathname == "/forgotPassword"){
 
        props.onHide();
        return (
            <ForgotPassword/>
        )
    }


    if(location.pathname == "/resetPassword"){
 
        props.onHide();
        return (
            <PasswordReset/>
        )
    }


   

    if(location.pathname == "/"){
        return  (
            <React.Fragment>
                        <Homepage />
                        {context.cookiePolicy != "true" && <Cookie/>}
                    </React.Fragment>
        )
    }

    return  (
            <React.Fragment>
                        
                        <Not_found/>
                        {context.cookiePolicy != "true" && <Cookie/>}
                    </React.Fragment>
        )



   
   
}